<div class="form-group">
  <label *ngIf="label" [attr.for]="inputId">
    <span>{{ label }}</span>
    <span *ngIf="require" class="text-danger" aria-hidden="true">*</span>
  </label>
  <select #field="ngModel" [id]="inputId" class="form-control shadow-none" [disabled]="readonly" [(ngModel)]="inputValue"
    [required]="require"
    [attr.aria-required]="require ? 'true' : null"
    [attr.aria-invalid]="errorShown ? 'true' : null"
    [attr.aria-describedby]="describedByIds"
    (blur)="errorState.schedule()">
    <option [value]="" disabled selected hidden>{{ placeholder }}</option>
    <option *ngFor="let item of options" [value]="item[valExp]">
      {{ item[displayExp] }}
    </option>
  </select>
  <div *ngIf="helperText" [id]="helperId" class="form-text uc-helper-text">{{ helperText }}</div>
  <div item-alert aria-live="polite">
    <div *ngIf="errorShown" [id]="errorId" role="alert" class="form-errors text-danger my-1 py-1">
      <div *ngIf="field.errors?.required">{{ 'validation.required' | translate }}</div>
    </div>
  </div>
</div>
